import { FC, useEffect, lazy, Suspense } from "react";

import { Box, Container, Center, Spinner } from "@chakra-ui/react";
import AOS from "aos";

import { NavbarHeight } from "theme";
import { AboutPageId, WorkPageId, MusicPageId, TestimonialPageId } from "utils/useScroll";

import "./App.scss";
import "aos/dist/aos.css";

const Navbar = lazy(() => import("shared/navbar/Navbar").then((module) => ({ default: module.Navbar })));
const Landing = lazy(() => import("pages/landing/Landing").then((module) => ({ default: module.Landing })));
const PageHeader = lazy(() =>
    import("shared/page-header/PageHeader").then((module) => ({ default: module.PageHeader })),
);
const Footer = lazy(() => import("shared/footer/Footer").then((module) => ({ default: module.Footer })));
const FeaturedProjects = lazy(() =>
    import("pages/featured-projects/FeaturedProjects").then((module) => ({
        default: module.FeaturedProjects,
    })),
);
const OtherProjects = lazy(() =>
    import("pages/other-projects/OtherProjects").then((module) => ({
        default: module.OtherProjects,
    })),
);
const About = lazy(() => import("pages/about/About").then((module) => ({ default: module.About })));
const Music = lazy(() => import("pages/music/Music").then((module) => ({ default: module.Music })));
const Testimonials = lazy(() => import("pages/testimonials/Testimonials").then((module) => ({ default: module.Testimonials })));


const Loader: FC = () => (
    <Center w="100%" h="100%">
        <Spinner size="lg" color="primary.500" />
    </Center>
);


export const App: FC = () => {
    useEffect(() => {
        AOS.init({ once: true });
    }, []);

    return (
        <Suspense fallback={<Loader />}>
            <Container h="100%" px={{ base: 6, md: 6, lg: 4 }}>
                <Navbar />

                <Box mt={{ base: "96px", md: NavbarHeight }}>
                    <Landing />
                    <Box id={WorkPageId}>
                        <PageHeader label="Featured Projects" />
                        <FeaturedProjects />

                        <PageHeader id="page-other-projects" label="Other Projects" />
                        <OtherProjects />
                    </Box>

                    <Box id={AboutPageId}>
                        <PageHeader label="About Me" />
                        <About />
                        <PageHeader label="Testimonials" />
                        <div className="relative mt-10 md:mt-24 md:order-4 w-full h-[200px]">
                            <iframe
                                src="https://trustugc.com/widget/c9gjjUqvhgaRJZVx3Tli9gJhLaI3?id=92e73c20-05a3-4319-baa7-4d387f8a3388"
                                style={{ width: "100%", height: "350px", border: "none", overflow: "hidden" }}
                                scrolling="no"
                            ></iframe>
                            <script async type="text/javascript" src="https://trustugc.com/scripts/widget-loader.js"></script>
                        </div>
                    </Box>
                    <Box id={MusicPageId}>
                        <PageHeader label="Music" />
                        <Music />
                    </Box>
                </Box>
                <PageHeader label="Get In Touch" />
                <Footer />
            </Container>
        </Suspense>
    );
};

